// src/components/ServiciosValue/ServiciosValue.jsx
import React from 'react';
import { motion } from 'framer-motion';
import styles from './ServiciosValue.module.scss';
import serviciosImg from '../../assets/images/ServiciosValue/servicios-value.webp';

const feature = {
  subtitle: "Propuesta de valor",
  text: "Diseñamos, fabricamos y respaldamos maquinaria pesada de última generación para construcción, minería, agricultura e industria, para que tu operación nunca se detenga."
};

const containerVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.8 } }
};

const overlayVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, delay: 0.3 } }
};

const ServiciosValue = () => (
  <motion.div
    className={styles.container}
    style={{ backgroundImage: `url(${serviciosImg})` }}
    variants={containerVariants}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
  >
    <motion.div
      className={styles.overlay}
      variants={overlayVariants}
      // Al hacer hover: ajustar el fondo a un blanco más opaco
      whileHover={{ backgroundColor: 'rgba(255, 255, 255, 1)' }}
      // Transición suave de fondo
      transition={{ duration: 0.3 }}
    >
      <h3 className={styles.subtitle}>{feature.subtitle}</h3>
      <p className={styles.text}>{feature.text}</p>
    </motion.div>
  </motion.div>
);

export default ServiciosValue;
